/**
 * Retry a promise-returning fn until success or attempts are exhausted.
 *
 * Belongs here: shared retry loop for expert-review mutations / manual fetches.
 * Does not belong here: toast, React Query, or min-duration.
 */
export async function withRetries<T>(
  runOnce: () => Promise<T>,
  maxAttempts: number
): Promise<T> {
  let lastError: unknown
  for (let attemptIndex = 0; attemptIndex < maxAttempts; attemptIndex++) {
    try {
      return await runOnce()
    } catch (error) {
      lastError = error
    }
  }
  throw lastError
}
